import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { login } from '../api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const res = await login(form.email.trim().toLowerCase(), form.password.trim());
      await loginUser(res.data.token, res.data.user);
      toast.success(`Welcome back, ${res.data.user.name}!`);
      window.location.replace(res.data.user.must_change_password ? '/change-password' : '/projects');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1 className="brand-name"><span className="brand-hicc">HICC</span>-<span className="brand-src">SRC</span> <span className="brand-jv">JV</span></h1>
          <p>Inventory Management System</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="login-email">Email Address</label>
            <input id="login-email" className="form-control" type="email" autoComplete="username" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} required placeholder="you@company.com" />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="login-password">Password</label>
            <input id="login-password" className="form-control" type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} required placeholder="Password" />
          </div>
          <div className="form-group" style={{ marginTop: '-6px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: 'var(--text2)', cursor: 'pointer' }}>
              <input type="checkbox" checked={showPassword} onChange={e => setShowPassword(e.target.checked)} />
              Show password
            </label>
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '10px', marginTop: '8px' }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <div style={{ marginTop: '14px', textAlign: 'center' }}>
          <Link to="/forgot-password" className="text-muted" style={{ fontSize: '13px' }}>Forgot password?</Link>
        </div>
      </div>
    </main>
  );
}
